import { ApiGetRequest, ApiPutRequest } from '../api';
import { Apiv2GetRequest, Apiv2PutRequest } from '../api-v2';
import { showNotif } from './notification';

export const state = {
  data: {
    form: {},
    loading: false,
  },
};

export const getters = {
    form(state) {
      return state.data.form;
    },
  };

export const mutations = {
  changeProfile(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getProfile({ commit }) {
    commit('changeProfile', {
      loading: true,
    });

    let result = await ApiGetRequest(`profile`);
    commit('changeProfile', {
      form: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async getProfilePrinciple({ commit }) {
    commit('changeProfile', {
      loading: true,
    });

    let result = await Apiv2GetRequest(`profile`);
    commit('changeProfile', {
      form: !result.error ? result.data.object : {},
    });

    return !result.error ? true : false;
  },

  async updateProfile({ commit, dispatch, state }) {
    commit('changeProfile', {
      loading: true,
    });
    
    const { data } = state;
    let result = await ApiPutRequest(`profile`, {
      ...data.form
    });

    if (result) {
      commit('changeProfile', {
          loading: false,
      });

      showNotif(dispatch, {
          message: result.data.message,
          type: 'success',
      });
    }

    return !result.error ? true : false;
  },

  async updateProfilePrinciple({ commit, dispatch, state }) {
    commit('changeProfile', {
      loading: true,
    });
    
    const { data } = state;
    let result = await Apiv2PutRequest(`profile`, {
      ...data.form
    });

    if (result) {
      commit('changeProfile', {
          loading: false,
      });

      showNotif(dispatch, {
          message: result.data.message,
          type: 'success',
      });
    }

    return !result.error ? true : false;
  }
};
